// extracted by css-extract-rspack-plugin
export default {"row":"EiCfY","cell":"ybqOt","table":"YsMWu","header":"o7Dg1","headerBadge":"YpKza","headerBadgeLabel":"ksqok","scrollContainer":"OWVig","body":"DliKY"};